
// src/components/auth/auth-logo.tsx
import Link from 'next/link';
import type { SVGProps } from 'react';
import { ParkingSquare } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { Locale } from '@/lib/i18n';
import { defaultLocale } from '@/lib/i18n';

interface AuthLogoProps extends SVGProps<SVGSVGElement> {
  currentLocale: Locale;
}

export function AuthLogo({ currentLocale, ...props }: AuthLogoProps) {
  const homePath = currentLocale === defaultLocale ? '/' : `/${currentLocale}`;

  return (
    <Link href={homePath} className="inline-block group" aria-label="ParkWise Home">
      <div
        className={cn(
          "flex items-center gap-2 h-full"
        )}
      >
        <ParkingSquare className="h-8 w-8 text-primary shrink-0 group-hover:text-primary/80 transition-colors" />
        <span className="text-xl font-semibold text-foreground truncate group-hover:text-primary/80 transition-colors">
          ParkWise
        </span>
      </div>
    </Link>
  );
}
